module.exports = __webpack_public_path__ + "img/undraw_Hamburger.2926ffd7.svg";